import React, {useEffect, useState} from "react";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  Typography,
} from "@mui/material";
import BasicTable from "./table/BasicTable";

function QCDetailModal({handleClose, tableQCData, detailsAPI, columns}) {
  const [qc, setQC] = useState(null);
  const [loader, setLoader] = useState(false);
  const [qcDetail, setQCDetail] = useState([]);

  useEffect(() => {
    async function getQCDetails() {
      try {
        setLoader(true);
        const response = await detailsAPI(tableQCData.ReceiptID);
        setQCDetail(response.data);
        setLoader(false);
      } catch (error) {
        setLoader(false);
        setQCDetail([]);
      }
    }
    if (tableQCData) {
      getQCDetails();
    }
    setQC(tableQCData);
  }, [tableQCData, detailsAPI]);

  return (
    <Dialog open={tableQCData} maxWidth="md" onClose={handleClose}>
      <DialogContent>
        {loader && <CircularProgress />}
        {!loader && (
          <Grid container>
            <Grid item lg={12} sm={12} xs={12} md={12}>
              <Typography omponent="h2" marginBottom={2} variant="h4">
                {qc ? `#${qc.PONumber}` : " "}
              </Typography>
              <BasicTable columns={columns} data={qcDetail} />
            </Grid>
          </Grid>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}

export default QCDetailModal;
